<template>
  <v-radio-group
    ref="radio_group"
    class="vuetify-radio-card"
    v-model="itemValue"
    :rules="itemRules"
  >
    <v-layout wrap justify-center>
      <v-flex
        v-for="(item, i) in items" :key="i" 
        xs12 sm6 md4 lg3
      >
        <v-radio :value="item.value"></v-radio>
          <v-card
            @click.native="selectItem(item)"
            :title="item.text"
            :class="[
              'vrc-card',
              (itemSelected && itemSelected.value === item.value) ? 'avatar-card' : '',
              'theme--light'
            ]"
            hover
            ripple 
            width="160px"
          >
            <v-card-media
              class="media"
              :src="item.avatar"
              height="160px"
            ></v-card-media>
            <v-card-title
              class="title-container text-xs-center"
              primary-title
            >
              <h3 class="title headline mb-0">
                {{ getFirstWord(item.text) }}
              </h3>
            </v-card-title>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 md4 lg3>
          <v-card
            @click.native="dialog = true"
            :title="aggregator.text"
            class="vrc-card theme--light"
            ripple 
            width="160px"
          >
            <v-card-media height="160px">
              <div class="icon-container">
                <v-icon class="icon">add</v-icon>
              </div>
            </v-card-media>
            <v-card-title
              class="title-container text-xs-center"
              primary-title
            >
              <h3 class="title headline mb-0">
                {{ aggregator.text }}
              </h3>
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>

      <v-layout v-show="aggregator" row justify-center>
        <v-dialog v-model="dialog" max-width="400px">
          <v-card>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex class="vrc-dialog" xs12>
                    <v-card-media class="vrc-carousel">
                      <v-carousel
                        :cycle="false"
                        hide-delimiters
                        :value="avatar"
                        v-model="avatar"
                      >
                        <v-carousel-item
                          v-for="(avatar, i) in defaultAvatars"
                          :key="i"
                          :src="avatar.src"
                          transition="fade"
                          reverse-transition="fade"
                        ></v-carousel-item>
                      </v-carousel>
                    </v-card-media>
                  </v-flex>
                  <v-flex xs12 class="vrc-gender">
                    <v-btn-toggle v-model="gender">
                      <v-btn flat value="male">
                        <span 
                          class="vrc-gender-title">
                          {{ aggregator.gender.man || 'man' }}
                        </span>
                        <svg class="vrc-gender-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path d="M16 2v2h3.586l-3.972 3.972c-1.54-1.231-3.489-1.972-5.614-1.972-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9c0-2.125-.741-4.074-1.972-5.614l3.972-3.972v3.586h2v-7h-7zm-6 20c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"/></svg>
                      </v-btn>
                      <v-btn flat value="female">
                        <span
                          class="vrc-gender-title">
                          {{ aggregator.gender.woman || 'woman' }}
                        </span>
                        <svg class="vrc-gender-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path d="M21 9c0-4.97-4.03-9-9-9s-9 4.03-9 9c0 4.632 3.501 8.443 8 8.941v2.059h-3v2h3v2h2v-2h3v-2h-3v-2.059c4.499-.498 8-4.309 8-8.941zm-16 0c0-3.86 3.14-7 7-7s7 3.14 7 7-3.14 7-7 7-7-3.14-7-7z"/></svg>
                      </v-btn>
                    </v-btn-toggle>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      ref="name"
                      v-model="name"
                      :label="aggregator.label || 'Name'"
                      :rules="aggregator.rules || []"
                      :autocomplete="aggregator.autocomplete || 'name'"
                      single-line
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :color="aggregator.color"
              flat @click.native="dialog = false"
            >
              close
            </v-btn>
            <v-btn
              :color="aggregator.color"
              flat
              @click.native="addItem(aggregator)"
              :disabled="!isValid"
            >
              {{ aggregator.buttons.save || 'save' }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-radio-group>
</template>

<script>

'use strict'
import VuetifySelectFile from '../vuetify-select-file'
export default {

  name: 'VuetifyRadioCard',
  model: {
    prop: 'selected',
    event: 'change'
  },
  props: {
    options: {
      type: Array,
      default: null,
      required: true
    },
    rules: {
      type: Array,
      default: null
    },
    avatars: {
      type: Object,
      default: null
    },
    value: {
      type: String,
      default: null
    },
    selected: {
      type: Object,
      default: null
    },
    valid: {
      type: Boolean,
      default: false
    },
    aggregator: {
      type: Object,
      default: null
    }
  },
  components: {
    VuetifySelectFile
  },
  data: () => ({
    items: null,
    itemSelected: null,
    itemValue: '',
    itemRules: [v => !!v || ''],
    isValid: false,
    dialog: false,
    avatar: 0,
    gender: null,
    name: '',
    defaultAvatars: [
      {
        src: 'http://localhost:8088/app/vue/src/components/vuetify-form-creator/fields/vuetify-radio-card/static/1.png'
      },
      {
        src: 'http://localhost:8088/app/vue/src/components/vuetify-form-creator/fields/vuetify-radio-card/static/2.png'
      },
      {
        src: 'http://localhost:8088/app/vue/src/components/vuetify-form-creator/fields/vuetify-radio-card/static/3.jpg'
      },
      {
        src: 'http://localhost:8088/app/vue/src/components/vuetify-form-creator/fields/vuetify-radio-card/static/4.png'
      },
      {
        src: 'http://localhost:8088/app/vue/src/components/vuetify-form-creator/fields/vuetify-radio-card/static/5.jpg'
      }
    ]
  }),

  mounted () {
    this.defaultAvatars = this.avatars || this.defaultAvatars
    this.items = this.options || this.items
    this.itemSelected = this.selected || this.itemSelected
    this.itemValue = this.value || this.itemValue
    this.itemRules = this.rules || this.itemRules
  },

  watch: {
    gender: function () {
      this.validateForm()
    },
    name: function () {
      this.validateForm()
    }
  },
  methods: {
    getFirstWord (text) {
      return text.split(' ')[0]
    },
    selectItem (item) {
      this.$refs.radio_group.reset()
      this.itemValue = item.value
      this.itemSelected = item
      this.$emit('change', item)
    },
    reset () {
      this.name = ''
      this.avatar = 0
      this.gender = null
      this.$refs.name.reset()
    },
    addItem (item) {
      this.dialog = false
      let newItem = {
        text: this.name,
        value: '0',
        gender: this.gender,
        avatar: this.defaultAvatars[this.avatar].src
      }
      let index = this.items.push(newItem) - 1
      this.items[index].value = (index + 1).toString()
      this.$emit('on-add-item', this.items[index])
      this.selectItem(this.items[index])
      setTimeout(() => { this.reset() }, 1000)
    },
    validateForm () {
      if (this.$refs.name.validate() && this.gender) {
        this.isValid = true
      } else {
        this.isValid = false
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.vuetify-radio-card

  .vrc-card
    margin-bottom: 30px
    .title
      width: -webkit-fill-available
      margin-top: -8px

    .media
      background: #f6f7f9

    .title-container
      height: 46px
    
    .icon
      font-size: 46px
      border-radius: 32px
      color: white
      padding: 4px
      background: #3F51B5

    .icon-container
      margin: auto

  .radio
    visibility: hidden
    position: absolute

  .avatar-card
    box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px #212121

.vrc-dialog
  margin-top: -75px
  margin-bottom: -45px

.vrc-gender
  margin: auto
  display: table

.vrc-gender-icon
  margin-left: 5px

.vrc-gender-title
  margin-top: 3px
.vrc-carousel
  .fade
    &-enter-active, &-leave-active, &-leave-to
      transition: .3s ease-out
      position: absolute
      top: 0
      left: 0

    &-enter, &-leave, &-leave-to
      opacity: 0
</style>


// WEBPACK FOOTER //
// src/components/vuetify-form-creator/fields/vuetify-radio-card/vuetify-radio-card.vue